import { inject, Injectable } from '@angular/core';
import { CedricApiService } from '../../infrastructure/api/cedric.api.service';
import { map, Observable } from 'rxjs';
import {
  EventSubscription,
  EventsViewModel,
  IServerResponse,
} from '@aksia/models';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  private api = inject(CedricApiService);

  private controller: string = 'Events';

  getEventSubscriptionManagerViewModel(
    userId: number,
  ): Observable<IServerResponse & EventsViewModel> {
    return this.api
      .post(`${this.controller}/GetEventSubscriptionManagerViewModel`, {
        eventProcessorId: 1,
        userId,
      })
      .pipe(
        map((viewModel) => {
          // FIXME: remove this when backend is ready
          if (!viewModel.entityTypes?.length) {
            viewModel.entityTypes = [
              {
                id: -2,
                name: 'All Entity Types',
              },
              {
                id: -1,
                name: 'Entity',
              },
              {
                id: 18,
                name: 'Project Type',
              },
              {
                id: 19,
                name: 'Project Filter',
              },
            ];
          }
          return viewModel;
        }),
      );
  }

  deleteEventSubscription(
    eventSubscriptionId: number,
  ): Observable<IServerResponse> {
    return this.api.post(`${this.controller}/DeleteEventSubscription`, {
      eventSubscriptionId,
    });
  }

  saveEventSubscription(
    subscription: { userId: number } & EventSubscription,
  ): Observable<IServerResponse> {
    return this.api.post(`${this.controller}/SaveEventSubscription`, {
      subscription,
    });
  }
}
